import { useMemo } from 'react'
import { IEntityAppointmentSearchResponse } from '../typings'

export type EntityAppointmentMap = Map<number, boolean>

// call once, pass as props?
export function useGetEntitiesWithAppointment(
  entityIds: number[],
  responseEntities: IEntityAppointmentSearchResponse[],
  schedulingEnabled: boolean,
) {
  return useMemo(() => {
    const map: EntityAppointmentMap = new Map()
    const curDateTime = new Date()
    entityIds.map((entityId) => {
      const hasAppointment = responseEntities.some(
        (x) =>
          x.entityId === entityId &&
          x.status === 'Scheduled' &&
          x.workTime &&
          new Date(x.workTime) > curDateTime,
      )
      map.set(entityId, hasAppointment && schedulingEnabled)
    })
    return map
  }, [entityIds, responseEntities, schedulingEnabled])
}
